<template>
    <div>
        <!-- Revisar - input hidden helper -->
        <input
            type="hidden"
            name="date"
            :value="initialDate.start"
        >

        <input 
            type="hidden"
            name="end_date"
            :value="initialDate.end"
        >

        <label v-if="! noTitle">
            Periodo:
        </label>
        <vue-ctk-date-time-picker 
            v-model="initialDate"
            :only-date="true"
            :no-button-now="true"
            no-label
            locale="es-us"
            format="YYYY-MM-DD"
            formatted="LL"
            :auto-close="false"
            input-size="sm"
            :range="true"
            :first-day-of-week="0"
            @input="dateChanged"
            @is-shown="onShown"
            @is-hidden="onHidden"
            right
            color="#4A5568"
            no-shortcuts
        >
<!--            @is-hidden="$emit('is-hidden')"-->
        </vue-ctk-date-time-picker>
    </div>
</template>

<script>
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
import parse from 'date-fns/parse';
import format from 'date-fns/format';
import startOfWeek from 'date-fns/start_of_week';
import endOfWeek from 'date-fns/end_of_week';
import getDate from 'date-fns/get_date';
import startOfMonth from 'date-fns/start_of_month';
import endOfMonth from 'date-fns/end_of_month';
import setDate from 'date-fns/set_date';
import addDays from 'date-fns/add_days';
import differenceInDays from 'date-fns/difference_in_days';

export default {
    data() {
        return {
            initialDate: {
                start: null,
                shortcut: null,
                end: null
            },
            lastDate: null,
            customShortcuts: []
        };
    },
    components: {
        VueCtkDateTimePicker
    },
    props: {
        date: {
            type: String,
            default: ''
        },
        value: {
            type: Object,
            default: function () {
                return {
                    start: null,
                    end: null
                }
            }
        },
        payrollType: {
            type: Object,
            default: () => null
        },
        noTitle: {
            type: Boolean,
            default: false
        },
        openDates: {
            type: Boolean,
            default: false
        }
    },
    mounted() {
        this.initialDate.start = this.value.start;
        this.initialDate.end = this.value.end;
    },
    methods: {
        dateChanged(date) {
            if (date.start) {
                console.log('date has changed, date: ')
                console.log(date)
                this.setRange(date.start);
                this.$emit('input', { start: this.initialDate.start, end: this.initialDate.end });
                this.$emit('date-changed', { start: this.initialDate.start, end: this.initialDate.end });
            }
        },
        setRange(date) {
            if (this.payrollType === null || this.openDates) return;

            const dateObj = parse(date);
            const numberOfDays = parseInt(this.payrollType.number_of_days);

            const reference = this.payrollType.reference_date !== null 
                ? parse(this.payrollType.reference_date)
                : null; 
            
            switch (this.payrollType.name) {
                /* case 'weekly': 
                    this.initialDate.start = format(startOfWeek(dateObj), 'YYYY-MM-DD');
                    this.initialDate.end = format(endOfWeek(dateObj) ,'YYYY-MM-DD');
                    break; */
                case 'fortnightly':
                    let day = getDate(dateObj);
                    this.initialDate.start = day > 15 ? format(setDate(dateObj, 16), 'YYYY-MM-DD') : format(startOfMonth(date), 'YYYY-MM-DD');
                    this.initialDate.end = day > 15 ? format(endOfMonth(date), 'YYYY-MM-DD') : format(setDate(dateObj, 15), 'YYYY-MM-DD');
                    break;
                case 'weekly':
                case 'fourteen':
                    if (this.payrollType.reference_date === null) {
                        this.initialDate.start = format(startOfWeek(dateObj, { weekStartsOn: parseInt(this.payrollType.initial_day)}), 'YYYY-MM-DD');
                    } else {
                        let diff = differenceInDays(dateObj, reference);
                        this.initialDate.start = format(addDays(
                            reference,
                            numberOfDays * (Math.floor(diff / numberOfDays)) 
                        ), 'YYYY-MM-DD');
                    }

                    this.initialDate.end = format(addDays(new Date(this.initialDate.start + ' 00:00:00'), numberOfDays) - 1, 'YYYY-MM-DD');
                    break;
                default:
                    
            }
        },
        onShown(){
            /*
            * Save date on shown to detect date change on hidden event
            * */
            if (this.date == null) {
                this.lastDate = '';         //initial empty date
            } else {
                this.lastDate = this.date;  //initial valid date
            }
        },
        onHidden(){
            /*
            * When hidden event is fired, we'll check for date change
            * */
            if (this.lastDate != null && this.lastDate != '' && this.lastDate != this.date) {
                //console.log('Date has truly changed');
                this.reloadReports();
            } else if (this.lastDate == '' && this.date != null) {
                //console.log('Date has truly changed for first time');
                this.reloadReports();
            }
            this.lastDate = null;
            //console.log('Final date: ' + this.date);
        },
        reloadReports() {
            // window.location.href = 'payroll-reports?date=' + this.date;
        },
        recoverRequestedDate(date){
            this.initialDate.start = date;
        }
    },
    watch: {
        'value.start': function (newValue) {
            this.initialDate.start = newValue;
        },
        'value.end': function (newValue) {
            this.initialDate.end = newValue;
        }
    }
}
</script>

